import { BaseOwnerEntity } from "../entity/baseOwnerEntity";

export class Note extends BaseOwnerEntity {
  id?: number;
  noteTypeId?: number;
  name?: string;
  imageUrl?: string;
  backgroundColor?: string;
  showNote?: boolean;
  screenOrderNo?: number;
  status?: number;
}
